<template>
  <div id="product-content-planners">
     <!-- Loading spinner for the entire page --> 
    <div v-if="isLoading" class="loading-overlay">
      <center><b-spinner large></b-spinner></center>
    </div>

    <div v-else-if="plans.length < 1" class="tasks">
        <div class="empty-list"> No Plans Available </div>
    </div>

    <b-tabs v-else v-model="currentActiveTab" nav-class="main-tabs nav nav-tabs" 
      nav-wrapper-class="main-tabs-row" content-class="eb-content-wrapper">
      
      <!-- <b-tab :active="isActiveTab(0)">
        <template v-slot:title>
          <div class="tab-title-wrapper">
            <span class="tab-title">All Plans</span>
            <span class="tab-subtitle">10 Days Planner - 3 Aug to 10 Sep</span>
          </div>
        </template>
        <Planners :plans="unactivePlans"/>
      </b-tab> -->

      <!-- <b-tab :active="isActiveTab(1)">
        <template v-slot:title>
          <div class="tab-title-wrapper">
            <span class="tab-title">My Plans</span>
             <span class="tab-subtitle">10 Days Planner - 3 Aug to 10 Sep</span>
          </div>
        </template>
        <Planners :plans="activePlans"/>
      </b-tab> -->

      <b-tab v-for="(plan, index) in unactivePlans" :active="isActiveTab(index)">
        <template v-slot:title>
          <div class="tab-title-wrapper">
            <span class="tab-title">{{ plan.title }}</span>
          </div>
        </template>
        <PlanDetail :plan="plan"/>
      </b-tab>
<!-- 
      <b-tab :active="isActiveTab(1)">
        <template v-slot:title>
          <div class="tab-title-wrapper">
            <span class="tab-title">Chapt: Name will come here</span>
            <span class="tab-subtitle">10 Days Planner - 3 Aug to 10 Sep</span>
          </div>
        </template>
        <PlanDetail/>
      </b-tab>

      <b-tab :active="isActiveTab(2)">
        <template v-slot:title>
          <div class="tab-title-wrapper">
            <span class="tab-title">Chapt: Name will come here</span>
            <span class="tab-subtitle">10 Days Planner - 10 Sep to 10 Oct</span>
          </div>
        </template>
        <PlannerTasks />
      </b-tab> -->
    
    </b-tabs>

    <!-- For now later will be remove direct 
    <PlanDetail/> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Planners from './Planners/Planners.vue'
import PlanDetail from "./Planners/PlanDetail.vue";
import PlannerTasks from "./Planners/PlannerTasks.vue"

export default {
  name: "ProductContentPlanners",
  components: {
    Planners,
    PlanDetail,
    PlannerTasks,
  },
  data() {
    return {
      isLoading: true,
      currentActiveTab: 0,
      plans: [],
    };
  },
  methods: {
    ...mapActions("planner", ["getPlanners"]),

    isActiveTab(index) {
      return this.currentActiveTab === index;
    },
    changeTab(tabName) {
      const query = { ...this.$route.query, tab: tabName };
      this.$router.push({ query }).catch(() => {});
    },

    async loadPlans() {
      this.plans = await this.getPlanners(this.$route.params.id) || [];
      this.isLoading = false;
    },
  },
  computed: {
    ...mapState("user", ["user"]),

    unactivePlans() {
      return this.plans.filter(plan => plan.isTemplate);
    },

    activePlans() {
      return this.plans.filter(plan => plan.userID && this.user.id === plan.userID);
    }
  },
  created(){
    this.loadPlans();
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab) {
          this.currentActiveTab = newTab.toLowerCase() === 'plannersection' ? 0 : 1;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>

#product-content-planners .eb-content-wrapper {
  max-height: calc(100dvh - var(--header-height) - 60px);
  overflow: auto;
  padding: 0px;
}

#product-content-planners .main-tabs-row {
  height: auto; 
  padding: 0px;
}

#product-content-planners .main-tabs a,
#product-content-planners .main-tabs .nav-link {
  height: 60px;
  padding: 0px 20px;
  line-height: normal;
}

#product-content-planners .nav {
    display: block; 
    overflow-x: auto; 
    white-space: nowrap; 
    padding: 0px 40px;
}

#product-content-planners .nav-item {
    display: inline-block; 
    float: none !important;
    height: 60px;
    margin: 0; 
}

</style>

<style scoped>

.tab-title-wrapper {
  display: flex;
  flex-direction: column;
}

.tab-title-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%; 
  box-sizing: border-box; 
}

.tab-title {
  color: #000;
  font-family: "Circular Std";
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: normal;
  letter-spacing: -0.36px;
}

.tab-subtitle {
  color: var(--primary-color);
  font-family: "Circular Std";
  font-size: 10.5px;
  font-style: normal;
  font-weight: 450;
  line-height: normal;
}

.loading-overlay{
  margin-top: 38dvh;
  margin-bottom: 38dvh;
}

.empty-list {
    display: flex;
    justify-content: space-around;
    font-size: 15px;
    margin-top: 25dvh;
    margin-bottom: 35dvh;
    font-weight: 700;
}


</style>
